export const linkToPaymentMethod = (countrySubDomain, lang) => {
  const paymentMethodLink = {
    ae: {
      ar: "https://support.opensooq.com/hc/ar/sections/360005816017-%D8%A7%D9%84%D8%A5%D9%85%D8%A7%D8%B1%D8%A7%D8%AA",
      en: "https://support.opensooq.com/hc/en-us/sections/360005816017-UAE",
    },
    bh: {
      ar: "https://support.opensooq.com/hc/ar/sections/360005816017-%D8%A7%D9%84%D8%A8%D8%AD%D8%B1%D9%8A%D9%86",
      en: "https://support.opensooq.com/hc/en-us/sections/360005816017-Bahrain",
    },
    dz: {
      ar: "https://support.opensooq.com/hc/ar/sections/360005816017-%D8%A7%D9%84%D8%AC%D8%B2%D8%A7%D8%A6%D8%B1",
      en: "https://support.opensooq.com/hc/en-us/sections/360005816017-Algeria",
    },
    eg: {
      ar: "https://support.opensooq.com/hc/ar/sections/360005816017-%D9%85%D8%B5%D8%B1",
      en: "https://support.opensooq.com/hc/en-us/sections/360005816017-Egypt",
    },
    iq: {
      ar: "https://support.opensooq.com/hc/ar/sections/360005816017-%D8%A7%D9%84%D8%B9%D8%B1%D8%A7%D9%82",
      en: "https://support.opensooq.com/hc/en-us/sections/360005816017-Iraq",
    },
    jo: {
      ar: "https://support.opensooq.com/hc/ar/sections/360005816017-%D8%A7%D9%84%D8%A3%D8%B1%D8%AF%D9%86",
      en: "https://support.opensooq.com/hc/en-us/sections/360005816017-Jordan",
    },
    kw: {
      ar: "https://support.opensooq.com/hc/ar/sections/360005816017-%D8%A7%D9%84%D9%83%D9%88%D9%8A%D8%AA",
      en: "https://support.opensooq.com/hc/en-us/sections/360005816017-Kuwait",
    },
    lb: {
      ar: "https://support.opensooq.com/hc/ar/sections/360005816017-%D9%84%D8%A8%D9%86%D8%A7%D9%86",
      en: "https://support.opensooq.com/hc/en-us/sections/360005816017-Lebanon",
    },
    ly: {
      ar: "https://support.opensooq.com/hc/ar/sections/360005816017-%D9%84%D9%8A%D8%A8%D9%8A%D8%A7",
      en: "https://support.opensooq.com/hc/en-us/sections/360005816017-Libya",
    },
    ma: {
      ar: "https://support.opensooq.com/hc/ar/sections/360005816017-%D8%A7%D9%84%D9%85%D8%BA%D8%B1%D8%A8",
      en: "https://support.opensooq.com/hc/en-us/sections/360005816017-Morocco",
    },
    mr: {
      ar: "https://support.opensooq.com/hc/ar/sections/360005816017-%D9%85%D9%88%D8%B1%D9%8A%D8%AA%D8%A7%D9%86%D9%8A%D8%A7",
      en: "https://support.opensooq.com/hc/en-us/sections/360005816017-Mauritania",
    },
    om: {
      ar: "https://support.opensooq.com/hc/ar/sections/360005816017-%D8%B9%D9%8F%D9%85%D8%A7%D9%86",
      en: "https://support.opensooq.com/hc/en-us/sections/360005816017-Oman",
    },
    ps: {
      ar: "https://support.opensooq.com/hc/ar/sections/360005816017-%D9%81%D9%84%D8%B3%D8%B7%D9%8A%D9%86",
      en: "https://support.opensooq.com/hc/en-us/sections/360005816017-Palestine",
    },
    qa: {
      ar: "https://support.opensooq.com/hc/ar/sections/360005816017-%D9%82%D8%B7%D8%B1",
      en: "https://support.opensooq.com/hc/en-us/sections/360005816017-Qatar",
    },
    sa: {
      ar: "https://support.opensooq.com/hc/ar/sections/360005816017-%D8%A7%D9%84%D8%B3%D8%B9%D9%88%D8%AF%D9%8A%D8%A9",
      en: "https://support.opensooq.com/hc/en-us/sections/360005816017-Saudi-Arabia",
    },
    sd: {
      ar: "https://support.opensooq.com/hc/ar/sections/360005816017-%D8%A7%D9%84%D8%B3%D9%88%D8%AF%D8%A7%D9%86",
      en: "https://support.opensooq.com/hc/en-us/sections/360005816017-Sudan",
    },
    sy: {
      ar: "https://support.opensooq.com/hc/ar/sections/360005816017-%D8%B3%D9%88%D8%B1%D9%8A%D8%A7",
      en: "https://support.opensooq.com/hc/en-us/sections/360005816017-Syria",
    },
    tn: {
      ar: "https://support.opensooq.com/hc/ar/sections/360005816017-%D8%AA%D9%88%D9%86%D8%B3",
      en: "https://support.opensooq.com/hc/en-us/sections/360005816017-Tunisia",
    },
    ye: {
      ar: "https://support.opensooq.com/hc/ar/sections/360005816017-%D8%A7%D9%84%D9%8A%D9%85%D9%86",
      en: "https://support.opensooq.com/hc/en-us/sections/360005816017-Yemen",
    },
    tr: {
      ar: "https://support.opensooq.com/hc/ar/sections/360005816017-Turkey",
      en: "https://support.opensooq.com/hc/en-us/sections/360005816017-Turkey",
    },
  };
  return paymentMethodLink[countrySubDomain][lang];
};
